import React, {useEffect, useState} from 'react';
import {File as FWFile} from 'FW/Models/File';
import FileBlock from '../MediaLibrary/FileBlock';

export default function SingleFile(props) {
  const [file, setFile] = useState(null);
  const options = props.section.prop('options') || {};
  useEffect(() => {
    const f = FWFile.findOrCreate({
      id: options.file_id
    });
    f.ensureLoaded().then(() => {
      setFile(f);
    });
  }, [options.file_id]);

  return file ? <div style={{paddingBottom: '15px'}} className={'singleFileContainer'}>
    <FileBlock
      singleFile={true}
      showThumbnail={options.show_thumbnail}
      file={file}
    />
  </div> : <div />;
}
